export default __webpack_public_path__ + "static/Year1869-2bfffcdde79d291e70db78f1edeadfa9.png";